export const ACTION_GET_BUNDLE_ELEMENT = '/Catalog/GetBundleElement';